import {svgIconWrapper} from '../svg-icon-wrapper';

import WorldRegular from './world-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <WorldRegular {...validProps} />;
}

SvgComponent.iconName = 'worldRegular';

export const WorldRegularIcon = svgIconWrapper(SvgComponent);
